import script from "./upload-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./upload-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./upload-dialog.vue?vue&type=style&index=0&id=41c6b3ea&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c6b3ea"]])

export default __exports__